import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import type { MailingFormInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-form.dto';
import type { MailingTemplateFindInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-template-find.dto';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { MailingTemplateService } from '@zaoblako/web/core/services/report/mailing-template.service';
import { AutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/auto-complete/auto-complete.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { TemplateSubjectEditorComponent } from '@zaoblako/web/shared/dumbs/template-subject-editor/template-subject-editor.component';
import { TemplateSubjectInputComponent } from '@zaoblako/web/shared/dumbs/template-subject-input/template-subject-input.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';

@Component({
  selector: 'crm-newsletter-welcome-system-change-text',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    JoinPipe,
    TemplateSubjectEditorComponent,
    TemplateSubjectInputComponent,
    ButtonComponent,
    AutoCompleteComponent
  ],
  templateUrl: './newsletter-welcome-system-change-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterWelcomeSystemChangeTextComponent implements OnInit {
  public loading = true;
  public templates: MailingTemplateFindInterface[];
  public filterTemplates: MailingTemplateFindInterface[];
  @Input() public newsletter: MailingFormInterface;

  public errors: Record<keyof MailingFormInterface, any[]>;

  @Output() public next = new EventEmitter<void>();

  public constructor(
    private readonly mailingTemplateService: MailingTemplateService,
    private readonly errorService: ErrorService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.mailingTemplateService.findPage().subscribe({
      next: (page) => {
        this.templates = page.items ?? [];
        this.filterTemplates = page.items ?? [];
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }

  public changeTemplate(template: MailingTemplateFindInterface) {
    if (template?.id) {
      this.mailingTemplateService.findById<MailingTemplateFindInterface>(template.id).subscribe({
        next: (_template) => {
          this.newsletter.name = _template.name;
          this.newsletter.title = _template.title;
          this.newsletter.text = _template.text;
          this.cdRef.markForCheck();
        }
      });
    }
  }

  public nextClick() {
    this.errors = Object.create({});

    if (!this.newsletter.name || this.newsletter.name?.length < 2) {
      this.errors.name = ['Название должно содержать хотя бы два символа'];
    }

    if (!this.newsletter.text || this.newsletter.text?.length < 2) {
      this.errors.text = ['Текст сообщения должен содержать хотя бы два символа'];
    }

    if (!this.newsletter.title || this.newsletter.title?.length < 2) {
      this.errors.title = ['Тема письма должен содержать хотя бы два символа'];
    }

    if (Object.keys(this.errors).some((key) => this.errors[key])) {
      return;
    }

    this.next.emit();
  }

  public searchTemplates(event: { originalEvent: any; query: string }) {
    this.filterTemplates = this.templates.filter((template) => template.name.includes(event.query));
    this.cdRef.markForCheck();
  }
}
